module.exports = __webpack_public_path__ + "static/media/happy-instructor.5fcf8e58.png";